import type { ObjectOrganization, ObjectOwner, ProfileIdentity } from '@/domain';
import type { HostBadgesData } from '@/hooks/useHostBadges';
import { ProfileCompany } from '../profileCompany/ProfileCompany';
import { ProfilePublic } from '../profilePublic/ProfilePublic';

export type ProfileProps = {
    hostBadges: HostBadgesData;
    isImport: boolean;
    isPrivate: boolean;
    organisation?: ObjectOrganization;
    owner: ObjectOwner;
    profileIdentity?: ProfileIdentity;
};

export const Profile = ({ hostBadges, isImport, isPrivate, organisation, owner, profileIdentity }: ProfileProps) => {
    if (!owner) {
        return null;
    }

    // If import ads don't have any data they can use, don't show the profile at all
    if (isImport && !owner.mobile && !owner.phone && !organisation) {
        return null;
    }

    return (
        <div className="p-16 border rounded-8" data-testid="objectPage-profile">
            <div data-testid="adProfile" className="text-center">
                {isImport && <ProfileCompany organisation={organisation} />}

                {isPrivate && <ProfilePublic identity={profileIdentity} badges={hostBadges} />}
            </div>
        </div>
    );
};
